import type { SlotAwareField } from '@cli-types/core-engine/schema-reader.js'
import { collectSlotLayoutErrors } from './collect-slot-layout-errors.js'
import { walkSlotAwareField } from './walk-slot-aware-field.js'

export function walkSlot(field: SlotAwareField, fieldPath: string, errors: string[]): void {
  walkSlotAwareField(field, fieldPath, errors, {
    checkField: (current, currentPath, currentErrors) => {
      if (current.slot !== undefined && current.slot !== 'main' && current.slot !== 'sidebar') {
        currentErrors.push(
          `Field "${currentPath}" has invalid slot="${String(current.slot)}". Expected "main" or "sidebar".`
        )
      }
    },
    onTab: (tab, tabPath, currentErrors) => {
      if (tab.fields && tab.slot !== undefined) {
        currentErrors.push(`Tab "${tabPath}" cannot define both "fields" and "slot".`)
      }
      if (tab.slot !== undefined) {
        collectSlotLayoutErrors(tab.slot, `${tabPath}.slot`, currentErrors)
      }
    },
    descendTabSlots: false
  })
}
